import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link, useLocation } from "react-router-dom";

// Function to convert slug to normal text
const convertSlugToText = (slug) => {
  // Implement your logic to convert the slug to normal text
  // For simplicity, let's just replace hyphens with spaces
  return slug.replace(/-/g, " ");
};

export const BreadCrums = () => {
  const location = useLocation();
  const pathSegments = location.pathname
    .split("/")
    .filter((segment) => segment !== "");
  const excludedWords = ["test", "details"];
  const disabledLinks = [
    "organ",
    "conditions",
    "condition",
    "parameter",
    "test-detail",
    "details",
    "search",
  ];

  return (
    <>
      {location.pathname !== "/" &&
      location.pathname !== "/about-us" &&
      location.pathname.includes("campaign") !== true &&
      location.pathname !== "/pharmacy" ? (
        <section className="position-relative d-contents _BreadCrums">
          <div className="container">
            <div role="presentation" className="bread_crums ">
              <Breadcrumbs
                separator=">"
                className="mb-3 "
                aria-label="breadcrumb"
              >
                <Link to="/">Home</Link>
                {pathSegments.map((segment, index) => {
                  const path = `/${pathSegments.slice(0, index + 1).join("/")}`;
                  const isDisabled = disabledLinks.includes(segment);
                  const labelText = convertSlugToText(segment);

                  if (!excludedWords.includes(segment)) {
                    return (
                      <Link
                        key={segment}
                        component={isDisabled ? "span" : "a"}
                        to={isDisabled ? "" : path}
                      >
                        {labelText}
                      </Link>
                    );
                  }

                  return null;
                })}
              </Breadcrumbs>
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
};
